import { TextFieldProps as TextFieldPropsMui } from '@mui/material';
import { TextField, Typography } from 'styles';

type TextFieldProps = TextFieldPropsMui & { value: string; maxLength: number };

const TextFieldPopup: React.FC<TextFieldProps> = props => {
	return (
		<TextField
			sx={{
				height: 'fit-content',

				'.MuiFormHelperText-root': {
					mt: '8px !important',
					ml: '16px !important',
				},
			}}
			error={!!props.value && props.value.length > props.maxLength}
			inputProps={{ maxLength: props.maxLength }}
			fullWidth
			multiline
			helperText={
				<Typography variant="caption" color={theme => theme.palette.grey1.main}>
					{props.value.length || '0'}/{props.maxLength}
				</Typography>
			}
			{...props}
		/>
	);
};

export default TextFieldPopup;
